import { useState, useEffect, useCallback } from "react";
import { getMilestoneDelays } from "../../api/dashboardApi";

export default function useMilestoneDelays(zoneName) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDelays = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await getMilestoneDelays(zoneName);
      setData(res?.results || []);
    } catch (err) {
      console.error("Failed to load milestone delays:", err);
      setError(err);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [zoneName]);

  useEffect(() => {
    fetchDelays();
  }, [fetchDelays]);

  return { data, loading, error, refetch: fetchDelays };
}